module.exports = __webpack_public_path__ + "static/media/G-icon.fd77efa8.png";